<template>
    <div class="row">
        <div class="col">
            <div class="card card-form company-card">
                <div class="card-header certificate">
                    <div class="row">
                        <div class="col-12">
                            <div class="pull-left">
                                <span><i class="fa fa-list"></i> {{$t('companyRegistrationCertificate.title')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="form-group">
                                <label>{{$t('companyRegistrationCertificate.fullName')}} <span class="red">*</span></label>
                                <input type="text" class="form-control"
                                       v-model="companyRegistrationCertificate.fullName"
                                       :class="{invalid: $v.companyRegistrationCertificate.fullName.$error}">
                                <div class="red" v-if="!$v.companyRegistrationCertificate.fullName.required">{{$t('companyRegistrationCertificate.fullName')}}</div>
                            </div>
                            <div class="form-group">
                              <label>{{$t('companyRegistrationCertificate.shortName')}} <span class="red">*</span></label>
                              <input type="text" class="form-control"
                                     v-model="companyRegistrationCertificate.shortName"
                                     :class="{invalid: $v.companyRegistrationCertificate.shortName.$error}">
                              <div class="red" v-if="!$v.companyRegistrationCertificate.shortName.required">{{$t('companyRegistrationCertificate.shortName')}}</div>
                            </div>
                            <div class="form-group">
                              <label>{{$t('companyRegistrationCertificate.registrationNumber')}} <span class="red">*</span></label>
                              <input type="text" class="form-control"
                                     v-model="companyRegistrationCertificate.registrationNumber"
                                     :class="{invalid: $v.companyRegistrationCertificate.registrationNumber.$error}"
                              >
                              <div class="red" v-if="!$v.companyRegistrationCertificate.registrationNumber.required">{{$t('companyRegistrationCertificate.registrationNumber')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('companyRegistrationCertificate.registrationDate')}} <span class="red">*</span></label>
                                <custom-date-picker
                                    class="form-control"
                                    format="dd/MM/yyyy"
                                    v-model="companyRegistrationCertificate.registrationDate"
                                    :date="companyRegistrationCertificate.registrationDate"
                                    :clear-button="true">
                                </custom-date-picker>
                                <div class="red" v-if="!$v.companyRegistrationCertificate.registrationDate.required">{{$t('companyRegistrationCertificate.registrationDate')}}</div>
                            </div>
                        </div>
                        <drop-zone code="companyRegistrationCertificate"
                                   label="companyRegistrationCertificate.picture"
                                   view="XL"
                                   folder="Company"
                                   subFolder="CompanyRegistrationCertificate"
                                   :addRemoveLinks="hasCreate"
                                   :editable="hasCreate"
                                   :data="pictures"
                                   @change="(files) => {companyRegistrationCertificate.picture = files[0]}"
                                   :maxFiles="1"
                                   acceptedFiles="image/*"
                                   :has-error="$v.companyRegistrationCertificate.picture.id.$error"
                        ></drop-zone>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-12">
                            <div class="text-right">
                                <router-link tag="button"
                                             class="all-btn add-btn"
                                             v-if="!hasCreate && hasPermission('COMPANY_REGISTRATION_CERTIFICATE_ADD')"
                                             :to="{path: '/company-registration-certificate/new'}">
                                    <i class="fa fa-plus"></i>
                                    <span>{{$t('company.field.companyCreate')}}</span>
                                </router-link>
                                <button type="button"
                                        class="all-btn edit-btn"
                                        v-else-if="hasCreate && companyRegistrationCertificate.id==null && hasPermission('COMPANY_REGISTRATION_CERTIFICATE_ADD')"
                                        @click="save"
                                        :disabled="processing">
                                    <i class="fa fa-check"></i>
                                    <span>{{$t('action.save')}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DropZone from '@/views/dropZone/DropZone'
    // import Datepicker from 'vuejs-datepicker';
    import {required} from 'vuelidate/lib/validators';
    // import {formatDate} from "@/shared/utils";
    // import {formatDate, parseDate} from '@/shared/utils';
    import CustomDatePicker from '@/views/common/CustomDatePicker';


    export default {
        name: "CompanyRegistrationCertificateAddEditView",
        components: {
            DropZone,
            // Datepicker,
            CustomDatePicker
        },
        props: {
            data: Object
        },
        data() {
            return {
                processing: false,
                companyRegistrationCertificate: {
                    id: null,
                    fullName: '',
                    shortName: '',
                    registrationDate: null,
                    registrationNumber: '',
                    picture: {},
                    address: '',
                    givenBy: ''
                },
                pictures: []
            }
        },
        validations() {
            return {
                companyRegistrationCertificate: {
                    fullName: {
                        required
                    },
                    shortName: {
                        required
                    },
                    registrationDate: {
                        required
                    },
                    registrationNumber: {
                      required
                    },
                    picture: {
                        id: {
                          required
                        }
                    }
                }
            }
        },
        computed: {
          hasCreate() {
            console.log("this.$route.path = ", this.$route.path);
            return this.$route.path==='/company-registration-certificate/new'
          }
        },
        methods: {
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.processing = true;
                this.$http.post('/company-registration-certificate', this.companyRegistrationCertificate)
                    .then(res => {
                        this.processing = false;
                        if (res.status === 200) {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.company.success'),
                                type: 'success'
                            });

                            this.$router.push('/company/profile')
                        }
                    }, ()=> {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.company.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            }
        },
        created() {

        },
        watch: {
            data: {
                immediate: true,
                handler(val) {
                    if (val) {
                        this.companyRegistrationCertificate = val;
                        this.pictures.push(this.companyRegistrationCertificate.picture);
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .certificate {
        background-color: #00838f;
    }

    .card .card-header span {
        color: white;
        font-weight: bold;
        font-size: 15px;
    }
</style>